import { VIA_MCP_LABEL, type TicketEventEntry } from '@easyhelp/shared';

/**
 * Chi ha compiuto l'evento, come lo legge la cronologia: il nome e, se l'azione è arrivata da un client
 * MCP (#156, DEC-015 decisione 6), «via MCP» accanto in testo (non solo un'icona, WCAG 2.2 AAA):
 * «Massimo via MCP».
 */
export function eventActor(entry: Pick<TicketEventEntry, 'actor' | 'viaMcp'>): string {
  return entry.viaMcp ? `${entry.actor} ${VIA_MCP_LABEL}` : entry.actor;
}
